import { createStringMatcher } from '@pega/cosmos-react-core';
import type { RuleSelectProps, RuleType, RuleTypeExpandable } from '@pega/cosmos-react-build';

// Top level rule types per feature design.
export const baseRuleTypes: RuleTypeExpandable[] = [
  {
    id: 'Automation',
    name: 'Automation',
    type: 'Automation',
    count: 50,
    rules: []
  },
  {
    id: 'Decision',
    name: 'Decision',
    type: 'Decision',
    count: 25,
    rules: []
  },
  {
    id: 'Field',
    name: 'Field',
    type: 'Field',
    count: 100,
    rules: []
  },
  {
    id: 'Paragraph',
    name: 'Paragraph',
    type: 'Paragraph',
    count: 50,
    rules: []
  }
];

// Simulate a simple rules DB table with parameters to mock fetch against.
export const fetchRules = ({
  id,
  filter,
  ruleType,
  start = 0,
  step = 25,
  delay = 1000
}: {
  id?: string;
  filter?: string;
  ruleType?: RuleType;
  start?: number;
  step?: number;
  delay?: number;
}) => {
  let timeoutId: number;
  let rejectFn: (reason: 'Aborted') => void;

  const promise = new Promise<{
    total: number;
    results: {
      id: string;
      name: string;
      type: RuleType;
    }[];
  }>((resolve, reject) => {
    rejectFn = reject;
    timeoutId = window.setTimeout(() => {
      const end = start + step;
      const mockRules = baseRuleTypes
        .filter(({ type }) => (ruleType ? type === ruleType : true))
        .map(({ type, count }) => {
          return Array.from({ length: count! }, (_, i) => {
            const name = `${type} ${i + 1}`;
            return {
              id: name,
              name,
              type
            };
          });
        })
        .flat()
        .filter(({ name }) => (filter ? createStringMatcher(filter).test(name) : true))
        .filter(rule => (id ? rule.id === id : true));

      resolve({
        total: mockRules.length,
        results: mockRules.slice(start, end)
      });
    }, delay);
  });

  return {
    promise,
    abort: () => {
      window.clearTimeout(timeoutId);
      rejectFn('Aborted');
    }
  };
};

export const defaultRuleState: Pick<
  RuleSelectProps,
  'selectedRule' | 'filterValue' | 'loading' | 'ruleTypes' | 'items'
> = {
  selectedRule: undefined,
  filterValue: undefined,
  items: undefined,
  loading: false,
  ruleTypes: baseRuleTypes
};
